<ts-button
  type="stroked"
  color="accent"
  class="xs:hidden"
  icon="visibility"
  [matTooltip]="'Select columns'"
  [tsOverlayTriggerFor]="columnsSelectOverlayBox"
>
  Fields
  <ng-container *ngIf="displayColumns.length">
    <ts-badge [value]="displayColumns.length" [type]="'info'"></ts-badge>
  </ng-container>
</ts-button>

<ts-overlay #columnsSelectOverlayBox position="bottom" [transparentBackdrop]="true">
  <div class="nearby-field-def-panel">
    <div class="search-box">
      <mat-icon [svgIcon]="'search'"></mat-icon>
      <input
        type="text"
        placeholder="Enter field name"
        (input)="filterFields($event)"
        (keydown)="filterFieldsInputKeyDown($event)"
        [maxLength]="50"
        #newTagInput
      />
    </div>

    <div class="available-fields">
      <ng-container>
        <mat-checkbox
          *ngFor="let fieldDef of displayDefs; trackBy: trackByFn"
          [color]="'primary'"
          [checked]="displayColumns.includes(fieldDef.name)"
          (change)="toggleDisplayColumn(fieldDef.name, $event)"
        >
          {{ fieldDef.label }}
        </mat-checkbox>
      </ng-container>
    </div>
  </div>
</ts-overlay>
